import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import './TimeActionTemplate.style.less'
import { Space, Table } from 'antd'
import { orderBy } from 'lodash'
import { useMutation, useQuery } from 'react-query'
import {
  deleteTemplate,
  getTimeActionTemplates,
} from '../../template.transform'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import { isEmptyValue } from '@/utils/common'
import { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import AddTimeActionTemplatesModal from './AddTimeActionTemplateModal/AddTimeActionTemplateModal'
import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'

function TimeActionTemplates() {
  const [modalTimeActionTemplate, setModalTimeActionTemplate] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [searchText, setsearchText] = useState('')

  const onEdit = (data) => {
    setSelectedItem(data)
    setModalTimeActionTemplate(true)
  }

  const deleteTemplateMutation = useMutation(async (id: string) => {
    await deleteTemplate(id)
    await refetch()
  })

  const onDelete = async (id) => {
    await deleteTemplateMutation.mutateAsync(id)
  }

  const { data, isLoading, refetch } = useQuery(
    ['GET_TIME_ACTION_TEMPLATES', searchText],
    async () => {
      const payload = {
        search: searchText,
      }
      return await getTimeActionTemplates(payload)
    }
  )

  const columns: ColumnsType<DataType> = [
    {
      title: 'NAME',
      dataIndex: 'name',
      align: 'left',
      key: 'name',
      render: (value) => (!isEmptyValue(value) ? value : <p>-</p>),
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => {
              onEdit(record)
            }}
            onDelete={() => onDelete(record.id)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div>
      <HeaderComponent title="Time & Action Templates" />
      <ToolbarComponent isSearch={true} onSearch={setsearchText} />
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={orderBy(data, ['created_date'], ['desc'])}
      />
      {modalTimeActionTemplate && (
        <AddTimeActionTemplatesModal
          visible={modalTimeActionTemplate}
          onClose={() => setModalTimeActionTemplate(false)}
          data={selectedItem}
        />
      )}
    </div>
  )
}

export default TimeActionTemplates
